import axios from 'axios';
import { setupAxios } from '@carvana/core-auth';

import { BASE_API_URL } from './helpers';

const authenticatedAxios = setupAxios(axios.create({ baseURL: BASE_API_URL }), {
  addBearerTokenToAllRequests: true
});

export default authenticatedAxios;